import { find } from 'lodash';
import { isPast } from 'date-fns';

export const eventCalendar = {
  namespaced: true,
  state: {
    rawEvents: [],
    sortedEvents: {},
    currenntEvents: [],
    fetching: false,
  },
  mutations: {
    updateRawEvents(state, events) {
      state.rawEvents = [...state.rawEvents, ...events];
    },
    updateSortedEvents(state, events) {
      state.sortedEvents = { ...state.sortedEvents, ...events };
    },
    updateCurrentEvents(state, month) {
      state.currenntEvents = [...state.sortedEvents[month]];
    },
    updateFetching(state, fetching) {
      state.fetching = fetching;
    },
  },
  actions: {
    setRawEvents: ({ commit }, events) => {
      commit('updateRawEvents', events);
    },
    setSortedEvents: ({ commit }, events) => {
      commit('updateSortedEvents', events);
      commit('updateCurrentEvents', Object.keys(events)[0]);
    },
    setCurrentEvents: ({ state, commit }, month) => {
      if (state.sortedEvents[month] != undefined) {
        commit('updateCurrentEvents', month);
        return;
      }
      commit('updateFetching', true);
      fetch(`${window.rest.url}events-calendar/events/${month}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      })
        .then(res => res.json())
        .then(res => {
          commit('updateRawEvents', res.rawEvents);
          commit('updateSortedEvents', { ...res.sortedEvents });
          commit('updateCurrentEvents', month);
          commit('updateFetching', false);
        });
    },
  },
  getters: {
    getPartnersEvents({ rawEvents }) {
      return filterByOwner(rawEvents, 'zcci-partners');
    },
    getZcciEvents({ rawEvents }) {
      return filterByOwner(rawEvents, 'zcci');
    },
    getCalendar(state, getters) {
      let partnerEvents = getters.getPartnersEvents.map(
        event => event.date.start
      );
      let zcciEvents = getters.getZcciEvents.map(event => event.date.start);
      return [
        {
          bar: {
            style: {
              backgroundColor: 'var(--bs-primary)',
            },
          },
          dates: zcciEvents,
        },
        {
          bar: {
            style: {
              backgroundColor: 'var(--bs-secondary)',
            },
          },
          dates: partnerEvents,
        },
      ];
    },
    getCurrentPartnersEvents({ currenntEvents }) {
      return sortByDate(filterByOwner(currenntEvents, 'zcci-partners'));
    },
    getCurrentZcciEvents({ currenntEvents }) {
      return sortByDate(filterByOwner(currenntEvents, 'zcci'));
    },
  },
};

// Helpers
function filterByOwner(events, ownerSlug) {
  return events.filter(event => find(event.owners, { slug: ownerSlug }));
}

function sortByDate(events) {
  const forwardEvents = [];
  const pastEvents = [];

  events.forEach(event => {
    isPast(new Date(event.date.start))
      ? pastEvents.push(event)
      : forwardEvents.push(event);
  });

  forwardEvents.sort(
    (a, b) =>
      new Date(a.date.start).getTime() - new Date(b.date.start).getTime()
  );

  pastEvents.sort(
    (a, b) =>
      new Date(b.date.start).getTime() - new Date(a.date.start).getTime()
  );

  return [...forwardEvents, ...pastEvents];
}
